import mixitup from 'mixitup';

$(() => {
  $('#menu-header-menu li.menu-item-has-children').append('<div class="toggle lg:hidden absolute z-20 top-0 right-0 px-2 py-1"><svg class="svg-inline--fa fa-chevron-down fa-w-14" aria-hidden="true" focusable="false" data-prefix="fa" data-icon="chevron-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="var(--text)" d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"></path></svg></div>');

  var timing = 200;

  $('#menu-header-menu > li.menu-item-has-children > .toggle').click(function() {
    if ($(this).parent().hasClass('open')) {
      $(this).parent().parent().find('li.menu-item-has-children').removeClass('open');
      $(this).parent().parent().find('.sub-menu').slideUp(timing);
    } else {
      $(this).parent().parent().find('li.menu-item-has-children.open').removeClass('open');
      $(this).parent().parent().find('li.menu-item-has-children.open > .sub-menu').slideUp(timing);
      $(this).parent().toggleClass('open');
      $(this).prev().slideToggle(timing);
    }
  });

  $('#menu-header-menu > li.menu-item-has-children > .sub-menu > li.menu-item-has-children > .toggle').click(function() {
    if ($(this).parent().hasClass('open')) {
      $(this).parent().parent().find('li.menu-item-has-children').removeClass('open');
      $(this).parent().parent().find('.sub-menu').slideUp(timing);
    } else {
      $(this).parent().parent().find('li.menu-item-has-children.open').removeClass('open');
      $(this).parent().parent().find('li.menu-item-has-children.open > .sub-menu').slideUp(timing);
      $(this).parent().toggleClass('open');
      $(this).prev().slideToggle(timing);
    }
  });

  // Desktop nav
  $('#menu-header-menu > li > .sub-menu > li.menu-item-has-children').hover(function() {
    if( $(window).innerWidth() > 991 ) {
      var target = $(this).find('> ul.sub-menu');
      var width = $(target).outerWidth();

      var right_of_screen = $(window).innerWidth();
      var right_of_parent = $(this).offset().left + $(this).outerWidth();
      var right_of_element = right_of_parent + width;

      if (right_of_screen > right_of_element){
        $(target).css('transform', 'translateX(100%)');
        $(target).css('right', '0');
      } else {
        $(target).css('transform', 'translateX(-100%)');
        $(target).css('left', '0');
      }
    }
  });

  $('.slick-banner').on('init', function() {
    var hiddenSlides = $('.slick-banner .hidden');
    if(hiddenSlides.length > 1) {
      $('.slick-banner .hidden').each(function(i, el) {
        $(el).removeClass('hidden');
      })
    } else {
      hiddenSlides.removeClass('hidden');
    }
  })

  // Slick
  $('.slick-banner').slick({
    dots: true,
    arrows: false,
    fade: true,
    cssEase: 'ease-in-out',
    slidesToShow: 1,
    slidestoScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    infinite: true,
  });

  $('.slick-intro').slick({
    dots: true,
    arrows: false,
    fade: false,
    cssEase: 'ease-in-out',
    slidesToShow: 1,
    slidestoScroll: 1,
    vertical: true,
    verticalSwiping: true,
    pauseOnHover: false,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    infinite: true,
    draggable: true,
    // centerMode: true,
  });

   // Page Links Slick 
   $('.pageLinksSlick').slick({
    dots: false,
    arrows: false,
    fade: false,
    cssEase: 'ease-in-out',
    slidesToShow: 3,
    slidestoScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    infinite: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow:2,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow:1,
        },
      },
    ],
  });

  // testimonialSlider
  $('.testimonialSlider').slick({
    dots: false,
    arrows: false,
    fade: false,
    cssEase: 'ease-in-out',
    slidesToShow: 1,
    slidestoScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    infinite: true,
    adaptiveHeight: true,
  });

  $('.slick-back').click(function() {
    let testimonialSlider = $('.testimonialSlider') ;
    $(testimonialSlider).slick('slickPrev');
  });
  $('.slick-forward').click(function() {
    let testimonialSlider = $('.testimonialSlider') ;
    $(testimonialSlider).slick('slickNext');
  });

  // Landing Page Gallery Slider
  $('.slick-gallery-landing').slick({
    dots: false,
    infinite: false,
    slidesToShow: 2,
    autoplay: true,
    slidesToScroll: 1,
    draggable: true,
    centerMode: false,
  });

  $('.slick-p').click(function() {
    $(this).parent().prev().slick('slickPrev');
  });
  $('.slick-n').click(function() {
    $(this).parent().prev().slick('slickNext');
  });

  // Mixitup
  if( $('.mix-container').length ) {
    var mixer = mixitup('.mix-container');
    if(mixer) {
      console.log('mix');
    }
  }

  // Smooth Scroll 
  $('.btn-scroll').on('click', function (e) {
    e.preventDefault()
    $('html, body').animate(
      { scrollTop: $($(this).attr('href')).offset().top - 150 }, 400
    );
  })

  $('a[href*="#"]:not([href="#"])').click(function() {
    var target = $(this.hash);
      $('html,body').stop().animate({
        scrollTop: target.offset().top - 100
      }, 1100);   
  });    
  if (location.hash){
    var id = $(location.hash);
  }
  $(window).load(function() {
      if (location.hash){
        $('html,body').animate({scrollTop: id.offset().top -100}, 800)
      };
  });

  // Cookie Policy
  $.fn.CookieNotice = function() {
    if (!localStorage.getItem('cookie-notice-dismissed')) {
      var notice = this;
      setTimeout(function() {
        notice.addClass('active');
      }, 1000);
    }
    this.addClass('cookie-notice');
    return this
  }
  $(document).on('click', '.cookie-notice-dismiss', function() {
    localStorage.setItem('cookie-notice-dismissed', true);
    $(this).parents('.cookie-notice').removeClass('active');
  })
  $('#cookie-notice').CookieNotice();

  // Share Button
  $('.page-share').click(function() {
    if( navigator.share ) {
      navigator.share({
        title: 'Share This Page',
        url: window.location,
      }).then(() => {
        console.log('Thanks for sharing!');
      })
      .catch(err => {
        console.log('Couldnt share because of', err.message);
      });
    } else {
      $('#panel-share').toggleClass('active');
      console.log('navigator.share not supported!')
    }
  });

  $('.panel-share-close').click(function() {
    $('#panel-share').removeClass('active');
  });

  // Mobile Nav
  $('#nav-primary-toggle').click(function() {
    $('.nav-primary').toggleClass('open');
    $('.nav-backdrop').toggleClass('show');
    if( $('.nav-primary').hasClass('open') ) {
      $('body').css('overflow','hidden')
    } else {
      $('body').css('overflow','auto')
    }
  });
  // Close Nav On Window Click
  $('.nav-backdrop').click(function() {
    alert('clicked');
    $('.nav-primary').toggleClass('open');
    $('.nav-backdrop').toggleClass('show');
    if( $('.nav-primary').hasClass('open') ) {
      $('body').css('overflow','hidden')
    } else {
      $('body').css('overflow','auto')
    }
  });
  

});

// Landing Page Gallery Slider
$('.slick-gallery-landing').slick({
  dots: false,
  infinite: false,
  slidesToShow: 2,
  autoplay: true,
  slidesToScroll: 1,
  draggable: true,
  centerMode: false,
});

  $('.toggle').click(function() {
    var $this = $(this);
    var $parent = $this.parents('.checkout-step.active');
    $parent.removeClass('active');
    $parent.next().addClass('active');
  });

  var $document = $(document);
  $document.scroll(function() {
    if ($document.scrollTop() >= 800) {
      // user scrolled 50 pixels or more;
      // do stuff
      $('#fixed-sidebar').addClass(' block')
      $('#fixed-sidebar').removeClass("hidden");

    } else {
      $('#fixed-sidebar').removeClass("block");
      $('#fixed-sidebar').addClass(' hidden')

    }
  });

  $(".toggler").click(function () {
    $(this).parents('#fixed-sidebar').toggleClass('hide');
  });

  // product tabs 

  $('.techTab').on('click', function() {

    var target = $(this).data('target');
    $('.techTab').removeClass('active');
    $(this).addClass('active');
    $('.techTabContent').removeClass('active');
    $(target).addClass('active'); 

    
    // change gallery based in tech tab active
    console.log(target)
    if ( $('.product-gallery-filter[data-filter="' + target + '"]').length ) {
      console.log('match')
      $('.product-gallery-filter').removeClass('active')
      $('.product-gallery-filter[data-filter="' + target + '"]').addClass('active');
      $('.productGallery-image').removeClass('active')
      $('.productGallery-image'+target).addClass('active');
    } else {
      console.log('no match');
    }


    // Show Flexible content tabs
    $('.tabFlexContent').first().addClass('active');
    $('.tabFlexContent').removeClass('active');
    $('.tabFlexContent' + target).addClass('active');
    

    // Open first tab
    $('.tabFlexContent' + target).find('.specTab').removeClass('active');
    let firstDataTarget = $('.tabFlexContent' + target).find('.specTab').first().data('target')
    $('.specTabContent').removeClass('active');
    $('.tabFlexContent' + target).find('.specTab').first().addClass('active');
    $(firstDataTarget).addClass('active');

})

$('.specTab').on('click', function() {

    var target = $(this).data('target');
    $('.specTab').removeClass('active');
    $(this).addClass('active');
    $('.specTabContent').removeClass('active');
    $(target).addClass('active'); 
    if($(target).find('.configurations .img').hasClass('config_image_slick')) {
      $('.config_image_slick').slick({
        dots: true,
        fade: false,
        arrows: false,
        cssEase: 'ease-in-out',
        slidesToShow: 1,
        slidestoScroll: 1,
        speed: 1000,
        infinite: true,
      });
    }

})

// Product Gallery (Product Page)
var filter = $('.product-gallery-filter');
$(filter).on('click', function() {
  var target = $(this).data('filter');
  $(filter).removeClass('active')
  $(this).addClass('active');

  $('.productGallery-image').removeClass('active')
  $('.productGallery-image'+target).addClass('active');
})

// Cta Block 
$('#delivery').on('click', function() {
  if ( $('#delivery').prop('checked') == true ) {
    $('#deliveryPostcode').prop('disabled', false);
  } else {
    $('#deliveryPostcode').prop('disabled', true);
  }
})

$('#fileUpload').on('change', function() {
  const file = this.files[0].size / 1024;
  console.log(file)
  if (file >= 4096) {
    $('.invalid-feedback-upload').text('File is too large, please select a file less than 4mb');
    $('.is-valid').prop('disabled', true);
    $('.is-valid').css('opacity', '.3');
    console.log('large');
  } else {
    $('.invalid-feedback-upload').text('');
    $('.is-valid').prop('disabled', false);
    $('.is-valid').css('opacity', '1');
    console.log('okay');
  }
});